export default {
    en: {
        id: 'exercise2',
        title: 'Computer installations are down because of internal inefficiencies',
        titles: ['Insufficient supply of product', ' Underdeveloped marketing plans', ' Unavailable software'],
        answers: [
            {
                title: 'Have a problem'
            },
            {
                title: 'Know the solution'
            },
            {
                title: 'How implement?'
            }
        ],
        boxes: [
            {
                name: 'box1',
                title: 'Time',
            },
            {
                name: 'box2',
                title: 'Structure',
            },
            {
                name: 'box3',
                title: 'Degree',
            }
        ],
        correctAnswers: {
            box1: false,
            box2: false,
            box3: true
        },
        userAnswers: {
            box1: false,
            box2: false,
            box3: false
        },
        text: 'A company can have both internal inefficiencies and external ones. These three points were originally created by visualizing the process required to install computers (produce the hardware, add the software, develop a marketing plan, sell, service.  The author then classified the first three as Internal Inefficiencies, the others as External Inefficiencies.  Putting the first point first implies that, in the writer’s mind, it is the major cause of the problem.'
    }
}



// WEBPACK FOOTER //
// ./client/app/modules/courses/6/identifyingLogicaOrder/i18n/exercise2.js